










import {
    Component,
    Vue,
    Prop
} from 'vue-property-decorator';

@Component
export default class BlogItem extends Vue {
    @Prop({ required: true }) private title!: string;
    @Prop({ required: true }) private subTitle!: string;
    @Prop({ required: true }) private imgUrl!: string;
    @Prop({ required: true }) private date!: string;
    @Prop({ required: true }) private id!: string;
    get imgUrlStyle() {
        return `background-image: url(${this.imgUrl})` ;
    }
}
